import { render, staticRenderFns } from "./registerationReport.vue?vue&type=template&id=36199ab6&scoped=true"
import script from "./registerationReport.vue?vue&type=script&lang=js"
export * from "./registerationReport.vue?vue&type=script&lang=js"
import style0 from "./registerationReport.vue?vue&type=style&index=0&id=36199ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36199ab6",
  null
  
)

export default component.exports